<template src="./ManagePermissions.html"></template>

<script>
import mixins from "@/Mixins";

export default {
  mixins: [mixins],
  name: "manage-permissions",
  data() {
    return {
      users: [],
      usersPaginated: [],
      usersHistoric: [],
      windowWidth: 0,
      pagination: false,
      currentx: 1,
      numPages: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  mounted: function() {
    this.init();
  },
  watch: {
    currentx: function () {
      this.changePagination();
    }
  },
  methods: {
    init() {
      this.getUsers()
    },
    getUsers() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(this.$store.state.filooServer + "access/users?types=ADMIN&active=true", {
          headers: { Authorization: this.$session.get("bearer") }
        })
        .then(response => {
          if (response.status === 200) {
            this.usersHistoric = this.users = response.data
            this.$vs.loading.close(this.$refs.content)
            this.numPages = Math.ceil(this.users.length / 10);
            this.pagination = this.numPages > 1;
            this.changePagination();
          }
        })
        .catch(function() {
          this.$vs.loading.close(this.$refs.content)
        });
    },
    selectedUser(id) {
      this.$router.push(`manager-users/${id}`);
    },
    changePagination(){
      this.usersPaginated = this.users.slice(((this.currentx - 1) * 10), (this.currentx * 10));
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleSearch(search) {
      console.log(search)
      const vm = this;
      vm.currentx= 1;
      if (vm.testNullUndefinedEmpty(search)) {
        vm.users = vm.usersHistoric;
      } else {
        vm.users = vm.usersHistoric.filter((user) => user.email.includes(search));
      }
      vm.numPages = Math.ceil(vm.users.length / 10);
      vm.pagination = vm.numPages > 1;
      vm.changePagination();
    },
  },
}
</script>

<style lang="scss" src="./ManagePermissions.scss">
</style>
